import { render, staticRenderFns } from "./commonTouchLoading.vue?vue&type=template&id=d896e6d0&scoped=true"
import script from "./commonTouchLoading.vue?vue&type=script&lang=js"
export * from "./commonTouchLoading.vue?vue&type=script&lang=js"
import style0 from "./commonTouchLoading.vue?vue&type=style&index=0&id=d896e6d0&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d896e6d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/hybrid-app/ph-refusaldrainage-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d896e6d0')) {
      api.createRecord('d896e6d0', component.options)
    } else {
      api.reload('d896e6d0', component.options)
    }
    module.hot.accept("./commonTouchLoading.vue?vue&type=template&id=d896e6d0&scoped=true", function () {
      api.rerender('d896e6d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonTouchLoading.vue"
export default component.exports